import { render, staticRenderFns } from "./gene-lab-order.vue?vue&type=template&id=3fd688ac&"
import script from "./gene-lab-order.vue?vue&type=script&lang=js&"
export * from "./gene-lab-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports